import { Card, CardContent, CardHeader, Chip, styled } from "@mui/material";
import { ReactElement } from "react";

import { ShortCodeConfig } from "~frontend/__generated__/graphql";
import Table from "~frontend/components/Table";
import { palette } from "~frontend/theme";

type Row = {
  id: string;
  keyword: string;
  label: string;
  response: string;
};

const KeywordChip = styled(Chip)({
  marginLeft: 2,
  borderRadius: 0,
  backgroundColor: palette.lightOrange,
  fontWeight: 600,
  fontSize: "10px",
  padding: 0,
  height: "18px",

  "& .MuiChip-label": {
    padding: "4px",
  },
});

export default function FixedKeywords({
  shortcodeConfig,
}: {
  shortcodeConfig: ShortCodeConfig;
}): ReactElement {
  const rows: Row[] = shortcodeConfig.optInKeywords
    .map(keyword => ({
      id: keyword,
      keyword,
      label: "Opt In",
      response: shortcodeConfig.optInMessage,
    }))
    .concat(
      shortcodeConfig.optOutKeywords.map(keyword => ({
        id: keyword,
        keyword,
        label: "Opt Out",
        response: shortcodeConfig.optOutMessage,
      }))
    )
    .concat(
      shortcodeConfig.helpKeywords.map(keyword => ({
        id: keyword,
        keyword,
        label: "Help",
        response: shortcodeConfig.helpMessage,
      }))
    );

  return (
    <Card>
      <CardHeader title={`Fixed Keywords `} />

      <CardContent sx={{ px: 2, py: 1, backgroundColor: palette.lightestGray }}>
        <Table
          rows={rows}
          columns={[
            {
              key: "keyword",
              title: "Keyword",
              align: "left",
              sx: { width: "200px" },
              renderValue: row => (
                <>
                  {row.keyword} <KeywordChip label={row.label} />
                </>
              ),
            },
            {
              key: "message",
              title: "Message",
              align: "left",
              renderValue: row => <>{row.response}</>,
            },
          ]}
          containerSx={{
            "& .MuiTableCell-root": {
              borderBottom: "0",
            },
            "& .MuiTableRow-root": {
              borderBottom: `1px solid ${palette.lightGray}`,
              "&:last-child": {
                borderBottom: "0",
              },
            },
          }}
          noFooter
        />
      </CardContent>
    </Card>
  );
}
